import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { connectModal } from 'redux-modal';
import { SHORTCUT_DIALOG } from '../../../constants';
import translate from '../../TranslateHOC';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';
import { Icon as IconV2 } from '../../../v2/components/icon/Icon';

const ShortcutDialog = ({ show, strings, ...props }) => {
  const trans = strings;

  const handleCancel = () => {
    if (props.closeCallback) {
      props.closeCallback();
    }
    props.handleHide();
  };

  return (
    <Modal
      isOpen={show}
      overlayClassName="dialog__overlay"
      className="dialog__content"
      onRequestClose={handleCancel}
      role="dialog"
      ariaHideApp={true}
      contentLabel={trans.adBlockerDetected}
    >
      <DialogShortcut>
        <DialogTitle>{trans.keyboardShortcuts}</DialogTitle>
        <DialogMessage>
          <UL>
            <LI>
              <Instruction>{trans.toggleWelsh}</Instruction>
              <ShortCutContainer>
                <ShortCutButton>W</ShortCutButton>
                <Span>&</Span>
                <ShortCutButton>C</ShortCutButton>
              </ShortCutContainer>
            </LI>
            <LI>
              <Instruction>{trans.toggleEnglish}</Instruction>
              <ShortCutContainer>
                <ShortCutButton>E</ShortCutButton>
              </ShortCutContainer>
            </LI>
            <LI>
              <Instruction>{trans.skip5Sec}</Instruction>
              <ShortCutContainer>
                <ShortCutButton>A</ShortCutButton>
                <Span>&</Span>
                <ShortCutButton>
                  <IconV2 customLabel="arrow_back" size="small" />
                </ShortCutButton>
              </ShortCutContainer>
            </LI>
            <LI>
              <Instruction>{trans.fastForward5Sec}</Instruction>
              <ShortCutContainer>
                <ShortCutButton>D</ShortCutButton>
                <Span>&</Span>
                <ShortCutButton>
                  <IconV2 customLabel="arrow_back" size="small" />
                </ShortCutButton>
              </ShortCutContainer>
            </LI>
            <LI>
              <Instruction>{trans.pauseVideo}</Instruction>
              <ShortCutContainer>
                <ShortCutButton>SPACE</ShortCutButton>
              </ShortCutContainer>
            </LI>
          </UL>
        </DialogMessage>
        <DialogActionRow>
          <ButtonV2 onClick={handleCancel} label={trans.ok} size="small" />
        </DialogActionRow>
        <DialogClose onClick={handleCancel} aria-label={trans.cancel}>
          <IconV2 customLabel="close" size="small" />
        </DialogClose>
      </DialogShortcut>
    </Modal>
  );
};

const DialogShortcut = styled.div`
  position: relative;
`;

const DialogTitle = styled.div`
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.black90
      : props.theme.color.whiteFull};
  font-family: 'Gotham Narrow SSm 7r', 'Gotham Narrow SSm A',
    'Gotham Narrow SSm B', 'HelveticaNeue-Bold', 'Helvetica Neue Bold',
    'Helvetica Neue', Helvetica, Verdana, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.35px;
  padding-bottom: 6px;
`;

const DialogMessage = styled.div``;

const UL = styled.ul`
  margin: 1.3em 0 2em;
  padding: 0;
  list-style: none;
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.black90
      : props.theme.color.whiteFull};
`;

const ShortCutButton = styled.div`
  display: inline-flex;
  min-width: 20px;
  height: 40px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.whiteFull
      : props.theme.color.black50};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black25
        : props.theme.color.white25};
  span {
    width: 15px !important;
    height: 15px !important;
  }
`;

const LI = styled.li`
  display: flex;
  flex-direction: row;
  margin-bottom: 7px;
  &:last-of-type ${ShortCutButton} {
    width: 104px !important;
  }
`;

const Instruction = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const ShortCutContainer = styled.div`
  display: flex;
  width: 105px;
`;

const Span = styled.span`
  display: flex;
  align-items: center;
  padding: 0 5px;
`;

const DialogActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: -10px;
`;

const DialogClose = styled.button`
  position: absolute;
  padding: 0;
  top: -10px;
  right: -10px;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  span {
    width: 15px !important;
    height: 15px !important;
    background-color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.statusRed
        : props.theme.color.primaryFull};
  }
`;

export default translate(
  connectModal({ name: SHORTCUT_DIALOG, destroyOnHide: true })(ShortcutDialog)
);
